import { SvgIcon, SvgIconProps } from "@mui/material";

export const ChecklistIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} style={{ strokeWidth: "0.5" }}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <rect
        width="18"
        height="18"
        x="2.999"
        y="3.001"
        stroke="currentColor"
        stroke-width="1.5"
        rx="3"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M12.952 15.043h4M6.95 14.768l.92.828 1.85-1.666M12.952 10.043h4M6.95 9.768l.92.828L9.72 8.93"
      />
    </svg>{" "}
  </SvgIcon>
);
